import store from "@/store"

class Hls {
  constructor() {
    this.init = false
    this._player = "avplay"
  }
  _init = async () => {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    if (document.getElementById("videoplane")) document.getElementById("videoplane").remove()
    /* FOR STANDALONA WIDGET
    document.getElementById("player").innerHTML = '<object id="videoplane" type="application/avplayer"></object>'
    */
    this.init = true
    return true
  }

  start = async () => {
    return true
  }
  destroy = async () => {
    return this.stop(true)
  }
  async play(source, params) {
    const { useDRM } = params

    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    this.closeSubtitle()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      if (webapis.avplay.getState() !== "NONE") {
        webapis.avplay.stop()
        webapis.avplay.close()
      }
      webapis.avplay.open(__.media.getSource())
      if (["multicast"].includes(__.media.type)) webapis.avplay.setStreamingProperty("ENABLE_TTX", true)
      if (useDRM) webapis.avplay.setDrm("LYNK", "Initialize", JSON.stringify({ LYNKServer: "NONE", type: "1" }))
      webapis.avplay.prepareAsync(() => webapis.avplay.play())
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  stop = async (fromDestroy = false) => {
    let promise = await _$.progress.create(_$.progress.type.STOP)

    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      webapis.avplay.stop()
      webapis.avplay.close()
      _$.handler.emit("media_event", "stop")
    } catch (error) {
      fromDestroy ? promise.resolve(false) : promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  pause = async () => {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPaused", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      webapis.avplay.pause()
      _$.handler.emit("media_event", "pause")
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  continue = async () => {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      webapis.avplay.play()
      _$.handler.emit("media_event", "play")
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }

  /* Control Helpers */
  isSeekable = async () => {
    return webapis.avplay.getDuration() ? true : false
  }
  getDuration = async () => {
    return Math.floor(webapis.avplay.getDuration() / 1000)
  }
  getPosition = async () => {
    return Math.floor(webapis.avplay.getCurrentTime() / 1000)
  }
  setPosition = async second => {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      webapis.avplay.seekTo(parseInt(second * 1000))
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    /* Library Code */
    let subtitles = webapis.avplay.getTotalTrackInfo().filter(item => item.type === "TEXT"),
      hasCurrent = webapis.avplay.getCurrentStreamInfo().find(item => item.type === "TEXT") || {}
    /* Library Code */

    subtitles = subtitles.map(subtitle => {
      const subtitle_ = JSON.parse(subtitle.extra_info)
      return { key: subtitle.index, value: subtitle_.track_lang, selected: subtitle.index === hasCurrent.index }
    })

    if (!subtitles.length) return false
    else subtitles.unshift({ key: "off", value: "None", selected: !hasCurrent.index })

    return subtitles
  }
  setSubtitle = async pid => {
    if (pid === "off" || pid === -1)
      return webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.OFF, () => {})

    webapis.avplay.setSelectTrack("TEXT", parseInt(pid))
    webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.ON, () => {})
    return true
  }
  closeSubtitle = async () => {
    return this.setSubtitle(-1)
  }

  getLanguages = async () => {
    let audios = webapis.avplay.getTotalTrackInfo().filter(item => item.type === "AUDIO"),
      hasCurrent = webapis.avplay.getCurrentStreamInfo().find(item => item.type === "AUDIO") || {}
    /* Library Code */

    audios = audios.map(audio => {
      const audio_ = JSON.parse(audio.extra_info)
      return { key: audio.index, value: audio_.track_lang, selected: audio.index === hasCurrent.index }
    })

    if (!audios.length) return false
    return audios
  }
  setLanguage = async pid => {
    webapis.avplay.setSelectTrack("AUDIO", parseInt(pid))
    return true
  }
}

export default Hls
